import { render, staticRenderFns } from "./EventManagmentPage.vue?vue&type=template&id=745adbd4"
import script from "./EventManagmentPage.vue?vue&type=script&lang=js"
export * from "./EventManagmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports